import { useState } from "react";
import SmallStat from "./SmallStat";
import SubscriptionsList from "./SubscriptionsList";
import OrdersList from "./OrdersList";

const Dashboard = ({ account ,onRefresh}) => {
  const [dashboardState, setDashboardState] = useState({
    activeTab: "subscriptions",
    subscriptions: account?.subscriptions,
  });

  const handleChangeTab = (value) =>
    setDashboardState((prev) => ({ ...prev, activeTab: value }));

  return (
    <div className="mt-3 lg:mt-6 flex flex-col items-start justify-start gap-3">
      <div className="flex flex-col md:flex-row items-center justify-start gap-3 md:gap-6">
        <SmallStat
          count={account?.subscriptions?.length || 0}
          text="My Subscriptions"
          bg="#295B24"
          active={dashboardState.activeTab === "subscriptions"}
          handleChange={() => handleChangeTab("subscriptions")}
        />
        <SmallStat
          count={account?.orders?.length || 0}
          text="My Orders"
          bg="#31160D"
          active={dashboardState.activeTab === "orders"}
          handleChange={() => handleChangeTab("orders")}
        />
      </div>

      {dashboardState.activeTab === "subscriptions" && (
        <SubscriptionsList
          list={account?.subscriptions || []}
          fetchSubscriptions={onRefresh}
        />
      )}
      {dashboardState.activeTab === "orders" && (
        <OrdersList list={account.orders || []} />
      )}
    </div>
  );
};

export default Dashboard;
